<template>
  <main>
    <section
      class="newslater-area4 pb-120 wow fadeInDown animated login-section"
      data-animation="fadeInDown"
      data-delay=".4s"
    >
      <div class="container text-left" style="background: #fcfaf8">
        <div class="row align-items-center">
          <div class="col-xl-7 col-lg-7 col-md-12">
            <div class="section-title section-title2 mb-30">
              <h2>Login to continue</h2>
              <p>Please use your credentials and login to your account to access our courses.</p>
            </div>
            <form @submit.prevent="handleLogin" class="contact-form newslater mb-30">
              <div class="form-group" style="margin-bottom: 20px">
                <input
                  v-model="identifier"
                  class="form-control"
                  type="text"
                  placeholder="Email/Username"
                  required
                  style="margin-bottom: 10px; width: 85% !important"
                />
                <input
                  v-model="password"
                  class="form-control"
                  type="password"
                  placeholder="Password"
                  required
                  style="width: 85% !important"
                />
              </div>
              <input type="submit" class="btn ss-btn login-btn" value="Login" />
            </form>
            <router-link to="/forgot-password" style="display: inline-block"> Forgot password? </router-link>
            <div style="margin-top: 6px">
              Don't have an account?
              <router-link to="/signup">Signup</router-link>
            </div>
          </div>
          <div class="col-xl-5 col-lg-5 col-md-12 text-right">
            <img src="@/assets/img/bg/login-img.png" alt="Login" />
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { mapActions } from 'vuex';
import api from '@/services/api';
export default {
  name: 'Login',
  data() {
    return {
      identifier: '',
      password: '',
    };
  },
  methods: {
    ...mapActions(['login']), // Import login action from Vuex
    async handleLogin() {
      try {
        const response = await api.post('/auth/login', {
          identifier: this.identifier,
          password: this.password,
        });

        const user = response.data;
        this.login(user); // ✅ Store user data in Vuex

        let redirectUrl = '/dashboard'; // default
        if (user.role === 'admin') {
          redirectUrl = '/dashboard/allcourses';
        } else if (user.role === 'teacher') {
          redirectUrl = '/dashboard/allcourses';
        } else if (user.role === 'student') {
          redirectUrl = '/dashboard/mycourses';
        } else if (user.role === 'mentor') {
          redirectUrl = '/dashboard/mentor-dashboard';
        }

        // ✅ Check if user was redirected from a course page
        const storedRedirect = localStorage.getItem('redirectAfterLogin');
        if (storedRedirect) {
          redirectUrl = storedRedirect;
          localStorage.removeItem('redirectAfterLogin');
        }

        this.$router.push(redirectUrl); // ✅ Redirect user to course or dashboard
      } catch (error) {
        alert(`${error.response?.data?.message}`);
      }
    },
  },
};
</script>

<style scoped></style>
